export default {
  transition: {
    en: {
      label: "Delete",
    },
    pt: {
      label: "Deletar",
    },
  },
  state: {
    en: {
      initial: "Initial",
      final: "Final",
      delete: "Delete",
    },
    pt: {
      initial: "Inicial",
      final: "Final",
      delete: "Deletar",
    },
  },
  dialog: {
    transition: {
      en: "Edit transition",
      pt: "Editar transição",
    },
    state: {
      en: "Edit state",
      pt: "Editar estado",
    },
    initial: {
      en: "INITIAL ONLY",
      pt: "SÓ INICIAL",
    },
    final: {
      en: "ONLY FINAL",
      pt: "SÓ FINAL",
    },
    initialAndfinal: {
      en: "BOTH",
      pt: "AMBOS",
    },
    delete: {
      en: "DELETE",
      pt: "EXCLUIR",
    },
  },
};
